export function formatRelativeDate(dateStr: string | null | undefined, timezone: string = 'UTC'): string {
  if (!dateStr) return '-';

  // Нормализуем дату - если нет timezone указателя, считаем что это UTC
  let normalizedDateStr = dateStr;
  if (!dateStr.endsWith('Z') && !dateStr.includes('+') && !dateStr.includes('-', 10)) {
    normalizedDateStr = dateStr.replace(' ', 'T') + 'Z';
  }

  const date = new Date(normalizedDateStr);
  if (isNaN(date.getTime())) return '-';

  // Конвертируем в timezone пользователя
  const options: Intl.DateTimeFormatOptions = { timeZone: timezone };

  // Получаем компоненты даты в timezone пользователя
  const formatter = new Intl.DateTimeFormat('en-GB', {
    ...options,
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });

  const parts = formatter.formatToParts(date);
  const getPart = (type: string) => parts.find(p => p.type === type)?.value || '';

  const year = parseInt(getPart('year'));
  const month = parseInt(getPart('month')) - 1;
  const day = parseInt(getPart('day'));
  const time = `${getPart('hour')}:${getPart('minute')}`;

  // Получаем текущую дату в timezone пользователя
  const now = new Date();
  const nowFormatter = new Intl.DateTimeFormat('en-GB', {
    ...options,
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  });
  const nowParts = nowFormatter.formatToParts(now);
  const getNowPart = (type: string) => nowParts.find(p => p.type === type)?.value || '';

  const nowYear = parseInt(getNowPart('year'));
  const nowMonth = parseInt(getNowPart('month')) - 1;
  const nowDay = parseInt(getNowPart('day'));

  // Вычисляем разницу в днях
  const targetDate = new Date(year, month, day);
  const todayDate = new Date(nowYear, nowMonth, nowDay);
  const diffDays = Math.floor((todayDate.getTime() - targetDate.getTime()) / (1000 * 60 * 60 * 24));

  if (diffDays === 0) return `Today, ${time}`;
  if (diffDays === 1) return `Yesterday, ${time}`;
  if (diffDays >= 2 && diffDays <= 6) return `${diffDays} days ago`;

  // Форматируем месяц
  const monthFormatter = new Intl.DateTimeFormat('en-GB', {
    ...options,
    month: 'short',
  });
  const monthName = monthFormatter.format(date);

  if (year === nowYear) {
    return `${day} ${monthName}, ${time}`;
  }

  return `${monthName} ${year}`;
}
